import React, { useEffect, useState } from 'react';
import { X, Smartphone, Download } from 'lucide-react';
import appQr from '../assets/images/Kopartner.png';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.kopartner';
export const APP_STORE_URL = null; // update when iOS listing is live

const STORAGE_KEY = 'kopartner_app_download_popup_v1';

/**
 * First-visit popup: Download the App Now + QR scan
 */
const AppDownloadPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const seen = localStorage.getItem(STORAGE_KEY);
      if (seen) return;
      const t = setTimeout(() => setOpen(true), 900);
      return () => clearTimeout(t);
    } catch {
      setOpen(true);
    }
  }, []);

  const dismiss = () => {
    setOpen(false);
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (_) {}
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="app-download-title"
    >
      <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden border border-purple-100 animate-[fadeIn_0.35s_ease-out]">
        <button
          type="button"
          onClick={dismiss}
          className="absolute top-3 right-3 z-10 p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600"
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <div className="bg-gradient-to-r from-purple-600 via-fuchsia-600 to-pink-500 px-6 pt-8 pb-6 text-center text-white">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white/20 mb-3">
            <Smartphone className="w-7 h-7" />
          </div>
          <h2 id="app-download-title" className="text-2xl font-bold tracking-tight">
            Download the App Now
          </h2>
          <p className="mt-2 text-sm text-white/90 leading-relaxed">
            Scan the QR code with your phone to get the KoPartner app and book partners faster on the go.
          </p>
        </div>

        <div className="px-6 py-6 flex flex-col items-center gap-4">
          <div className="bg-white p-3 rounded-2xl border-2 border-purple-200 shadow-inner">
            <img
              src={appQr}
              alt="Scan QR to download KoPartner app"
              className="w-44 h-44 object-contain"
            />
          </div>
          <p className="text-xs text-gray-500 text-center max-w-xs">
            Point your camera at the QR code — or tap the button below to open Google Play.
          </p>

          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={dismiss}
            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold py-3.5 rounded-full hover:shadow-lg transition"
          >
            <Download size={18} />
            Download on Google Play
          </a>

          {APP_STORE_URL ? (
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={dismiss}
              className="w-full text-center text-sm font-medium text-purple-700 hover:underline"
            >
              Download on the App Store
            </a>
          ) : (
            <p className="text-xs text-gray-400">App Store — Coming Soon</p>
          )}

          <button
            type="button"
            onClick={dismiss}
            className="text-sm text-gray-500 hover:text-gray-700 py-1"
          >
            Continue on website
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadPopup;

